import { cn } from '../lib/cn'

interface SpeechBubbleProps {
  children: React.ReactNode
  title?: string
  className?: string
  delay?: number
  isVisible?: boolean
  tone?: 'begin' | 'grow'
}

export function SpeechBubble({ children, title, className, delay = 0, isVisible = true, tone = 'begin' }: SpeechBubbleProps) {
  const surfaceStyle = tone === 'begin'
    ? {
        background: 'linear-gradient(135deg, rgba(136, 199, 219, 0.68), rgba(168, 225, 223, 0.46))',
        border: '1px solid rgba(255, 255, 255, 0.75)',
        boxShadow: '0 18px 48px rgba(93, 151, 209, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.28)',
      }
    : {
        background: 'rgba(100, 100, 100, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      }

  return (
    <div
      className={cn(
        'relative px-4 py-3.5',
        'w-fit',
        'max-w-full',
        className
      )}
      style={{
        ...surfaceStyle,
        backdropFilter: 'blur(20px) saturate(150%)',
        WebkitBackdropFilter: 'blur(40px) saturate(180%)',
        borderRadius: '24px',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(8px)',
        transition: `opacity 0.6s ease-out ${delay}s, transform 0.6s ease-out ${delay}s`
      }}
    >
      {/* Title */}
      {title && (
        <p className="text-body font-medium mb-1 text-white tracking-[-0.015em]">
          {title}
        </p>
      )}
      {/* Description */}
      <p className="text-body-mobile font-regular text-white/90 tracking-[-0.015em] leading-relaxed">
        {children}
      </p>
    </div>
  )
}
